export default __webpack_public_path__ + "static/media/coconut_slide.42246566.jpg";